// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k7wb","index":"styles_index__2saLQ"};